import React, { useEffect, useRef, useState } from "react";
import "./CriarMotivoDefeitoModal.css";

const sanitizeMotivoInput = (value, max = 120) =>
  String(value ?? "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/[<>]/g, "")
    .toUpperCase()
    .slice(0, max);

const sanitizeMotivoSave = (value, max = 120) => sanitizeMotivoInput(value, max).trim();

export default function CriarMotivoDefeitoModal({ open, onClose, onSalvar }) {
  const [motivo, setMotivo] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const motivoRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setMotivo("");
    setBusy(false);
    setErr("");

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => motivoRef.current?.focus(), 0);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleSalvar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      const normalized = sanitizeMotivoSave(motivo);
      if (!normalized) throw new Error("Informe o motivo do defeito.");
      await onSalvar?.(normalized);
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ptcmd-overlay" onClick={onClose}>
      <div className="ptcmd-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Cadastrar motivo do defeito">
        <div className="ptcmd-head">
          <h3 className="ptcmd-title">Cadastrar Motivo do Defeito</h3>
          <button className="ptcmd-close" type="button" onClick={onClose} disabled={busy} aria-label="Fechar">
            x
          </button>
        </div>

        <div className="ptcmd-body">
          <label className="ptcmd-field">
            <span>Motivo do defeito</span>
            <input
              ref={motivoRef}
              type="text"
              value={motivo}
              onChange={(event) => setMotivo(sanitizeMotivoInput(event.target.value))}
              placeholder="Ex: TRINCA NA ALMA"
              autoComplete="off"
            />
          </label>
          {err ? <div className="ptcmd-error">{err}</div> : null}
        </div>

        <div className="ptcmd-foot">
          <button className="ptcmd-btn ptcmd-btn-ghost" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="ptcmd-btn ptcmd-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
}
